import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Message } from '../models/message';
import { baseURL, imageURL, SocketURL } from '../constants/base.url';

@Injectable({
  providedIn: 'root'
})
export class CommunityService {
  imageURL: any;

  constructor(private http: HttpClient) { }

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
  }

  // Get all messages
  getAllMessages(): Observable<{ success: boolean; messages: Message[] }> {
    return this.http.get<{ success: boolean; messages: Message[] }>(
      `${baseURL}community/chat/messages`,
      { headers: this.getAuthHeaders() }
    );
  }

  // Send new message (text only)
  sendMessage(content: string): Observable<any> {
    return this.http.post(
      `${baseURL}community/chat/send`,
      { content },
      { headers: this.getAuthHeaders() }
    );
  }

  uploadAttachment(formData: FormData) {
    return this.http.post(
      `${baseURL}community/chat/send`,
      formData,
      { headers: this.getAuthHeaders() }
    );
  }


}
